import { isURL } from '@/utils/isURL';

export function urlifyString(link?: Nullable<string>): [string, boolean] {
  if (!link) {
    return ['', false];
  }

  let parsedLink = link.trim();

  if (!isURL(parsedLink)) {
    parsedLink = `https://${parsedLink}`;
  }

  try {
    const url = new URL(parsedLink);

    return [url.toString(), true];
  } catch (e) {
    return [link, false];
  }
}
